module.exports = __webpack_public_path__ + "res/slides.6e81bea19ea46877271d3ec33d999771.webp";